import { MouseEventHandler, useState } from "react";
import { Popover, Nav, NavLink, Col, Row, NavItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-regular-svg-icons";
import { faAngleDown, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { IGlobal } from "config/config.interface";
import { useAppSelector } from "app/hooks";
import { IAppTranslations } from "lib/translations/interfaces/translations.interface";

export default function UserMenu({ translations }: { translations: IAppTranslations }) {
    const user = useAppSelector(state => state.user);
    const globalConfig = (global as any as IGlobal);

    const [userMenuActive, setUserMenuActive] = useState(false);
    const toggleUserMenu = () => {
        setUserMenuActive(!userMenuActive)
    }

    const handleGoToCertifiedUserDashboard = () => {
        window.location.href = globalConfig.config.URL_CERTIFIED_USER.replace("{token}", user.v2UserToken ?? "") + "/Dashboard";
    }

    const handleGoToCertifiedUserProjects = () => {
        window.location.href = globalConfig.config.URL_CERTIFIED_USER.replace("{token}", user.v2UserToken ?? "") + "/Projects";
    }

    const handleGoToCertifiedUserReports = () => {
        window.location.href = globalConfig.config.URL_CERTIFIED_USER.replace("{token}", user.v2UserToken ?? "") + "/Reports/Order";
    }

    const handleGoToProfile = () => {
        setUserMenuActive(false);
        setTimeout(() => {
            window.location.href = '/profile';
        })
    }

    const handleGoToAssessmentsDashboard = () => {
        setUserMenuActive(false);
        setTimeout(() => {
            window.location.href = '/assessments';
        })
    }

    const handleLogout = () => {
        setUserMenuActive(false);
        setTimeout(() => {
            window.location.href = '/logout';
        })
    }

    return (
        <>
            <Nav className="header-megamenu" style={{ marginRight: 25 }}>
                <NavItem>
                    <NavLink onClick={toggleUserMenu} id="PopoverMegaMenu" style={{ color: '#426da9' }}>
                        <div className="header-user" onClick={toggleUserMenu}>
                            <div style={{ fontWeight: 'bold' }}>{user.fullName}</div>
                            <div className="opacity-8" style={{ fontSize: '0.8rem' }}>{user.roleName}</div>
                        </div>
                        <FontAwesomeIcon className="ml-2 opacity-8" icon={faAngleDown} />
                    </NavLink>
                </NavItem>

                <Popover className="rm-max-width" placement="bottom-start" fade={false} trigger="legacy"
                    isOpen={userMenuActive} target="PopoverMegaMenu" toggle={toggleUserMenu}
                >
                    <div className="grid-menu">
                        <Row className="no-gutters">
                            <Col>
                                <Nav vertical style={{ paddingBottom: 20, paddingTop: 10 }}>
                                    <HeaderUserNavItem icon={faUser}
                                        linkName={translations.header_link_profile ?? 'test'}
                                        handleClick={handleGoToProfile}
                                    />
                                    <HeaderUserNavItem icon={faClipboard}
                                        linkName={translations.header_link_assessments}
                                        handleClick={handleGoToAssessmentsDashboard}
                                    />
                                    {(user.type !== globalConfig.config.USER_TYPE_PARTICIPANT) && (
                                        <>
                                            <HeaderUserNavItem icon={faClipboard}
                                                linkName={translations.header_link_dashboard}
                                                handleClick={handleGoToCertifiedUserDashboard}
                                            />
                                            <HeaderUserNavItem icon={faClipboard}
                                                linkName={translations.header_link_projects}
                                                handleClick={handleGoToCertifiedUserProjects}
                                            />
                                            <HeaderUserNavItem icon={faClipboard}
                                                linkName={translations.header_link_reports}
                                                handleClick={handleGoToCertifiedUserReports}
                                            />
                                        </>
                                    )}
                                    <HeaderUserNavItem icon={faArrowRightFromBracket}
                                        linkName={translations.header_link_logout}
                                        handleClick={handleLogout}
                                    />
                                </Nav>
                            </Col>
                        </Row>
                    </div>
                </Popover>
            </Nav>
        </>
    )
}

export interface IHeaderUserNavItem {
    linkName?: string;
    icon: any;
    handleClick: MouseEventHandler<HTMLAnchorElement>;
}
export const HeaderUserNavItem = ({ linkName, icon, handleClick }: IHeaderUserNavItem) => {
    return (
        <NavItem>
            <NavLink onClick={handleClick}>
                <FontAwesomeIcon icon={icon} className="nav-link-icon" />
                <span>{linkName}</span>
            </NavLink>
        </NavItem>
    );
}